<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card mb-3">
        <div class="card-header d-flex align-items-center">
          <span>
            {{ $t("Charge Tiers") }}
          </span>
          <b-button variant="link" class="ml-auto" pill @click="addNewChargeTier">
            <font-awesome-icon :icon="'plus-circle'"/>
            {{ $t('New Charge Tier') }}
          </b-button>
        </div>
        <div class="card-body">
          <div class="charges-tiers">
            <div class="row">
              <div class="col-md-12">
                <table class="table items-table mb-0">
                  <thead v-if="model.tiers && model.tiers.length > 0">
                  <tr>
                    <th class="border-top-0">
                      {{ $t('Fixed Amount') }}
                    </th>
                    <th class="border-top-0">
                      {{ $t('Percentage') }}
                    </th>
                    <th class="border-top-0">
                      <template v-if="model.tiers && model.tiers.length > 1">
                        {{ $t('Over') }}
                      </template>
                    </th>
                    <th class="border-top-0"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(tier, index) in model.tiers" :key="`tier-${index}`">
                    <td :class="{'border-top-0': index === 0}">
                      <currency-input-widget :label="false" :model="tier" attribute="fixed_amount"
                                             :rules="tier.percent ? 'min_value:0' : 'required|min_value:0'"
                                             :disabled="amountDisabled(index)"/>
                    </td>
                    <td :class="{'border-top-0': index === 0}">
                      <percentage-input-widget :label="false" :model="tier" attribute="percent"
                                               :rules="tier.fixed_amount ? 'max_value:100|min_value:0' : 'required|max_value:100|min_value:0'"
                                               :disabled="percentDisabled(index)"/>
                    </td>
                    <td :class="{'border-top-0': index === 0}">
                      <template v-if="model.tiers && model.tiers.length > 1">
                        <currency-input-widget :label="false" :model="tier" attribute="amount_over"/>
                      </template>
                    </td>
                    <td :class="{'border-top-0': index === 0}">
                      <template v-if="index > 0 || (model.tiers.length === 1 && enableFirstTierRemoval)">
                        <b-tooltip :target="`remove-charge-tier-button-${index}`" :title="$t('Delete')"/>
                        <font-awesome-icon class="text-danger hover-cursor"
                                           :id="`remove-charge-tier-button-${index}`"
                                           @click="removeChargeTierByIndex(index)"
                                           style="font-size: 1.5em;margin-top: .2em"
                                           :icon="'times'"/>
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";
  import ChargeTier from "@/core/components/charge-tiers/ChargeTiers.model";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";

  export default {
    name: "ChargeTiers",
    components: {CurrencyInputWidget, PercentageInputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      enableFirstTierRemoval: {
        type: Boolean,
        default: false
      },
      showChargeTierField: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      percentDisabled() {
        return index => !!this.model.tiers[index].fixed_amount
      },
      amountDisabled() {
        return index => !!this.model.tiers[index].percent
      }
    },
    methods: {
      init() {
        this.model.tiers = this.model.tiers.map(data => new ChargeTier(data));

        if (this.model.tiers.length === 0) {
          this.addNewChargeTier();
        }
      },
      addNewChargeTier() {
        this.model.tiers.push(new ChargeTier({amount_over: null, fixed_amount: null, rate: null}))
      },
      removeChargeTierByIndex(index) {
        for (let i = 0; i < this.model.tiers.length; i++) {
          if (i === index) {
            this.model.tiers.splice(i, 1);
            break;
          }
        }
      },
    },
    watch: {
      'model'() {
        if (this.model && this.model.tiers) {
          this.init();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .items-table {
    /deep/ .form-group {
      margin-bottom: 0;
    }
  }
</style>